import React, { createContext, useState } from 'react';

import { ThemeProvider, createTheme } from "@mui/material/styles";
import useMediaQuery from '@mui/material/useMediaQuery';

//export const ThemeContext = createContext({ toggleColorMode: () => { } });
export const ThemeContext = createContext();

export const ThemeContextProvider = props => {

	const prefersLightMode = false; // useMediaQuery('(prefers-color-scheme: light)');

	const [mode, setMode] = useState(localStorage.getItem("colorMode") ? localStorage.getItem("colorMode") : (prefersLightMode ? 'light' : 'dark'));

	// https://mui.com/material-ui/customization/dark-mode/
	const colorMode = React.useMemo(
		() => ({
			toggleColorMode: () => {
				setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
			}
		}),
		[]
	);

	const theme = React.useMemo(
		() =>
			createTheme({
				palette: {
					mode
				}
			}),
		[mode]
	);

	return <ThemeContext.Provider value={[colorMode, theme, mode]}><ThemeProvider theme={theme}>{props.children}</ThemeProvider></ThemeContext.Provider>;

};

export const useThemeContext = () => React.useContext(ThemeContext);

export default useThemeContext;
